import { Component, Output, EventEmitter, Input } from '@angular/core';

import { FullFacModel } from '../../../../core/models/edit-fac-modal.model';
import { EditFacModalService } from '../service/edit-fac-modal.service';
import { SnackbarService } from '../../snackbar/service/snackbar.service';
import { CheckTaskStatusService } from 'src/app/core/services/check-task-status-service/check-task-status-service';
import { ButtonsPopupService } from '../../buttons-popup/service/buttons-popup.service';
import { ButtonsPopupModel } from '../../buttons-popup/buttons-popup.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-modal-search-profile',
  templateUrl: './modal-search-profile.component.html',
  styleUrls: ['./modal-search-profile.component.scss']
})
export class ModalSearchProfileComponent {

  @Input() facItem: FullFacModel;
  @Output() openEdit = new EventEmitter<any>();
  @Output() openCreate = new EventEmitter<any>();

  constructor(
    private facModalService: EditFacModalService,
    private snackbarService: SnackbarService,
    private checkStatusService: CheckTaskStatusService,
    private btnsService: ButtonsPopupService,
    private environmentService: EnvironmentService
  ) { }

  editCard(index: number) {
    this.openEdit.emit(index);
  }

  removeCard(index: number) {
    const popModalOptions: ButtonsPopupModel = {
      title: 'Atenção',
      description: 'Deseja deletar o perfil de busca?',
      buttons: [
        {
          btnType: 3,
          title: 'Cancelar',
          func: () => {}
        },
        {
          btnType: 1,
          title: 'Deletar',
          func: () => {
            this.facModalService.deleteFacSearchProfile(this.facItem.id, this.facItem.search_profiles[index].id).subscribe(resp => {
              this.checkStatusService.checkTaskStatus(resp.taskId, this.environmentService.getEnvVar('api_facs')).subscribe(task => {
                this.snackbarService.show('As alterações foram salvas.', 'success');
                },
                err => {
                  this.snackbarService.show(err.error.messages[0].message, 'error');
                });
            });
            this.facItem.search_profiles.splice(index, 1);
          }
        },
      ]
    };

    this.btnsService.show(popModalOptions);
  }

  createCard() {
    this.openCreate.emit(true);
  }
}
